/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useRouter } from "next/navigation";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import ActionButton from "@/components/molecules/contact-details/action-button/action-button";
import { Routes } from "@/config/page-view-constants";
import { useSubmitReview } from "@/hooks/api/review-api/submit-review";
import useGtmPayNowOption from "@/hooks/gtm/quote-review/use-gtm-pay-now-option";
import { useQuoteDisabled } from "@/hooks/use-quote-disabled/use-quote-disabled";
import { useLoading } from "@/providers/loading-provider";
import { RootState } from "@/store/root-reducer";
import { updateQuote } from "@/store/slices/quote/quote.slice";
import QuoteCoverTypeMap from "@/utils/gtm/cover-type-map";
import QuoteDataMap from "@/utils/gtm/quote-data-map";
import { hidePersonalDetailsFields } from "@/utils/organiser.utils";

interface ReviewPageButtonPrpos {
  textBtn: string;
  passportIdValue?: string;
}

export default function ReviewPageButton({
  passportIdValue,
  textBtn,
}: Readonly<ReviewPageButtonPrpos>) {
  const { hideLoading, showLoading } = useLoading();
  const { attributes, referenceId, version, type } = useSelector(
    (state: RootState) => state.quote
  );
  const isQuoteDisabled = useQuoteDisabled();
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [newQuote, submitReview]: any = useSubmitReview(
    {
      version,
      type,
      attributes,
      referenceId,
      viewPage: Routes.QuoteReview,
      passportId: passportIdValue !== "" ? passportIdValue : undefined,
    },
    setButtonDisabled
  );
  const [totalToPay, setTotalToPay] = useState<string | undefined>();
  const dispatch = useDispatch();
  const router = useRouter();
  const { current } = useWizard();
  const [initiateGtmUpdate, setInitiateGtmUpdate] = useState(false);

  useEffect(() => {
    if (newQuote) {
      dispatch(updateQuote(newQuote));
      window.location.href = current.next ?? "";
    }
  }, [dispatch, newQuote, router, totalToPay]);

  useEffect(() => {
    if (attributes?.paymentDetails?.paymentOptions) {
      setTotalToPay(
        attributes?.paymentDetails?.paymentOptions[0]?.cardPayment?.card?.price
      );
    }
  }, [attributes]);

  let getDestination = null;
  if (attributes.tripDetails?.policyType === "SINGLE_TRIP") {
    getDestination = attributes.tripDetails?.toLocation;
  } else {
    getDestination = attributes.tripDetails?.area;
  }

  // GTM Trigger
  let gtmQuotePaymentData = null;
  let policyPackagesPayment = null;
  if (attributes) {
    gtmQuotePaymentData = QuoteDataMap(
      attributes,
      "begin_checkout",
      "checkout",
      referenceId
    );
    gtmQuotePaymentData = {
      ...gtmQuotePaymentData,
      ss_order_metrics: attributes.paymentDetails?.encryptedMarginValue,
      destination: getDestination,
    };
    policyPackagesPayment = QuoteCoverTypeMap(attributes);
  }

  useGtmPayNowOption({
    paymentData: gtmQuotePaymentData,
    policyItems: policyPackagesPayment,
    isReady: initiateGtmUpdate,
  });

  useEffect(() => {
    if (buttonDisabled) {
      showLoading();
    } else {
      hideLoading();
    }
  }, [buttonDisabled]);

  return (
    <div className="w-[316px] md:w-[352px]">
      <ActionButton
        id="review-page"
        disabledBtn2={
          buttonDisabled ||
          isQuoteDisabled ||
          (current.uiElementControls?.showPassportIdSection
            ? !passportIdValue
            : false)
        }
        disabledBtn1={isQuoteDisabled}
        ctaButton2Text={
          totalToPay && Number(totalToPay) <= 0 ? "Continue" : textBtn
        }
        onClickBtn2={() => {
          setInitiateGtmUpdate(true);
          submitReview();
          setButtonDisabled(true);
        }}
        onClickBtn1={() => {
          // If user is in variant flow, go to required information page
          if (hidePersonalDetailsFields(attributes?.experimentDetails)) {
            router.push("/informacion-requerida");
          } else {
            // Otherwise, use the default previous page
            router.push(current.prev ?? "");
          }
        }}
      />
    </div>
  );
}
